import React, { useEffect, useRef, useState } from "react";

import "./BybChooseBrand.css";
import ChooseBrew from "../../../assets/selfaudit/images/ChooseBrew.svg";
import { Link } from "react-router-dom";

function BybChooseBrand() {
  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  return (
    <>
      <section className="byb-choosebrand" id="choose_brew">
        <div className="container">
          <h1
            ref={textRef}
            className={`fade-in-text ${isVisible ? "visible" : ""}`}
          >
            Choose Your Brew
          </h1>

          <div className="byb-choosebrand-content">
            <div className="byb-choosebrand-content-one">
              <div className="byb-choosebrand-img">
                <img src={ChooseBrew} alt="Printed Brand Self-Audit Kit visual" />
              </div>
              <h5>Printed Kit</h5>
              <p>
                A tangible kit featuring high-quality tools and resources for
                hands-on brand development.
              </p>
              <div className="choosebrew-price">
                <div>
                  <p>Total Cost</p>
                  <h4 className="crossprize">{"\u20B9"}14,999</h4>
                </div>
                <div>
                  <p>Pre-Book for</p>
                  <h4>{"\u20B9"}7,999</h4>
                </div>
              </div>
              {/* <div className='type_form_btn apply_btn'>
                  <div data-tf-live="01JCZDETWSB110FG9DH0NDQAXG" style={{ width: '100%'}}></div>
              </div> */}
              <div className="type_form_btn">
                {/* <div data-tf-live="01JCZDETWSB110FG9DH0NDQAXG" style={{ width: '100%'}}></div> */}
                <Link
                  to={"https://rzp.io/rzp/brewyourbrand-checkout"}
                  className="blue_btn d-inline"
                >
                  Buy
                </Link>
              </div>
              {/* <button>Apply</button> */}

              <ul>
                <li>Brand Audit Tool</li>
                <li>Digital Audit Tool</li>
                <li>Brand Strategy Guide</li>
                <li>Visual Identity Guide</li>
                <li>Customer Journey Map</li>
                <li>Competitive Analysis Tool</li>
                <li>Marketing Best Practices</li>
                <li>26 Quick Tips for a Strong Brand</li>
                <li>26 Tactics to Master Marketing</li>
                <li>Survey Decks - Customer, Employee, Partner & Investor</li>
                <li>Brand Brewing Workbook</li>
                <li>Brew Your Brand - T-Shirt</li>
                <li>Diary & Pen</li>
              </ul>
            </div>
          </div>

          {/* <div className="choose-searchsection">
    <p className="choose-searchsection-text">Subscribe to our newsletter</p>
    <div className="choose-searchsection-input-container">
      <input type="email" className="choose-searchsection-input" placeholder="Your email" />
      <button className="choose-searchsection-button">
      <span><i className="fas fa-arrow-right"></i></span>  
      </button>
    </div>
  </div> */}

          <div className="choose-bottom-section">
            <img
              src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"
              alt="Brew Your Brand logo"
            />
            <h5>
              Unlock Powerful Insights Into Your Brand With the Brew Your Brand
              - Brand Self-Audit Kit
            </h5>
            <p>
              Designed as a founder-friendly resource for new business owners,
              entrepreneurs, brand enthusiasts, and brand managers, this kit
              combines brand audit prompts, brand strategy tools, and practical
              guidance to help you understand your brand's current position. It
              empowers you to uncover strengths, address areas for growth, and
              align your brand with your vision and goals.
            </p>

            <p>
              Take the first step toward transforming your brand - submit your
              application today and embark on this eye-opening journey!
            </p>

            {/* <button>Apply Now</button> */}
            {/* <div className='type_form_btn unlock_btn'>
                  <div data-tf-live="01JCZDETWSB110FG9DH0NDQAXG" style={{ width: '100%'}}></div>
              </div>
  </div> */}

            <div className="type_form_btn unlock_btn">
              <Link
                to={"https://rzp.io/rzp/brewyourbrand-checkout"}
                className="blue_btn d-inline"
              >
                Buy
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BybChooseBrand;
